import { creatorsApi } from 'api';
import { createFetchStore } from 'utils';

export const { useFetchStore: useTrendsStore, useFetchData: useFetchTrends } =
  createFetchStore<string[] | null>(creatorsApi.trends);
